import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall, postAPICallwithFile } from "../axiosMethodCall";

export const createFormAttachment = async (
  patient_id,
  attachment,
  doc_type,
  form_id,
  form_template_id,
  assessment_id,
) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());

    attachment?.forEach((data) => {
      formData.append("patient_id[]", patient_id);
      formData.append("attachments[]", data.file ? data.file : "");
      formData.append("doc_type[]", doc_type ? doc_type : "");
      formData.append("form_id[]", form_id ? form_id : "");
      formData.append(
        "form_template_id[]",
        form_template_id ? form_template_id : ""
      );
      formData.append("assessment_id", assessment_id);
    });

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "patient_attachments/create",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getMedicalSummary = async (id) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "forms/medical_summary",
      {
        requester: getUser(),
        token: getToken(),
        patient_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getFormHistory = async (data) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "forms/history",
      {
        requester: getUser(),
        token: getToken(),
        ...data,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getFormTemplates = async (data) => {
  try {
    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "forms/get_form_templates",
      {
        requester: getUser(),
        token: getToken(),
        ...data,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
